(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-gallery-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.cds:not([data-cds-init])');

    sections.forEach(function (root) {
      root.setAttribute('data-cds-init', '');

      var viewport = root.querySelector('[data-cds-viewport]');
      if (!viewport) return;
      var track = root.querySelector('[data-cds-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cds-slide]'));
      if (slides.length === 0) return;

      var originalCount = slides.length / 3;
      var currentOffset = 0;
      var setWidth = 0;

      function offsetFor(index) {
        return slides[index].offsetLeft;
      }

      function render(offset) {
        track.style.transform = 'translateX(' + -offset + 'px)';
      }

      function computeSetWidth() {
        setWidth = offsetFor(originalCount * 2) - offsetFor(originalCount);
      }

      function update() {
        computeSetWidth();
        currentOffset = offsetFor(originalCount);
        render(currentOffset);
      }

      function recenterIfNeeded() {
        if (!setWidth) return;
        var middleStart = offsetFor(originalCount);
        var lowerBound = middleStart - setWidth * 0.5;
        var upperBound = middleStart + setWidth * 1.5;

        if (currentOffset < lowerBound) {
          currentOffset += setWidth;
          track.style.transition = 'none';
          render(currentOffset);
          void track.offsetHeight;
          track.style.transition = '';
        } else if (currentOffset > upperBound) {
          currentOffset -= setWidth;
          track.style.transition = 'none';
          render(currentOffset);
          void track.offsetHeight;
          track.style.transition = '';
        }
      }

      var dragging = false;
      var startX = 0;
      var startOffset = 0;
      var lastX = 0;
      var lastTime = 0;
      var velocity = 0;
      var rafId = null;
      var pendingOffset = null;

      /* Pointer events fire faster than the browser paints, so rendering on
         every one of them queues up work it cannot keep up with. Batching to a
         single write per frame is what makes the drag feel smooth, on mobile
         especially where the event rate is highest. */
      function flushDrag() {
        rafId = null;
        if (pendingOffset === null) return;
        render(pendingOffset);
        pendingOffset = null;
        recenterIfNeeded();
      }

      function scheduleDrag(offset) {
        pendingOffset = offset;
        if (rafId === null) rafId = requestAnimationFrame(flushDrag);
      }

      viewport.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      viewport.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        dragging = true;
        startX = e.clientX;
        lastX = e.clientX;
        lastTime = performance.now();
        velocity = 0;
        startOffset = currentOffset;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;

        var now = performance.now();
        var elapsed = now - lastTime;
        if (elapsed > 0) velocity = ((e.clientX - lastX) / elapsed) * 16;
        lastX = e.clientX;
        lastTime = now;

        currentOffset = startOffset - (e.clientX - startX);
        scheduleDrag(currentOffset);
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;

        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
          pendingOffset = null;
        }

        viewport.classList.remove('is-dragging');

        /* Removing .is-dragging restores the track's transition, so nudging the
           offset by the release velocity makes it glide to a stop instead of
           halting dead under the finger. */
        if (Math.abs(velocity) > 1) currentOffset -= velocity * 10;

        render(currentOffset);
        recenterIfNeeded();
      }

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      root.setAttribute('data-cs2-init', '');

      var viewport = root.querySelector('[data-cs2-viewport]');
      var track = root.querySelector('[data-cs2-track]');
      if (!viewport || !track) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cs2-slide]'));
      if (slides.length === 0) return;

      // Die Liquid-Vorlage rendert 3 identische Sets hintereinander
      // (vorheriges Set / echtes Set / nächstes Set) für den Endlos-Loop.
      var originalCount = slides.length / 3;
      var current = originalCount + Math.min(1, originalCount - 1);
      var currentOffset = 0;

      /* Must match `height` on .cs2-slide / .cs2-slide.is-active. */
      var INACTIVE_SCALE = 0.82;

      /* Inactive slides shrink by height and their width follows via
         aspect-ratio, so when this runs the widths are still mid-transition and
         measuring offsetLeft/offsetWidth centres on the *old* size. A slide's
         width-per-unit-height is constant though, so the settled widths can be
         derived from it and the centring stays exact throughout the animation. */
      function offsetFor(index) {
        var trackHeight = track.clientHeight;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        /* .cs2-slide caps its width (70vw desktop, 84vw mobile), so read the
           resolved value rather than hardcoding one breakpoint's figure. All
           slides share the rule, so measuring the first is enough. */
        var maxWidth = parseFloat(getComputedStyle(slides[0]).maxWidth);
        if (!isFinite(maxWidth)) maxWidth = Infinity;
        var left = 0;
        var activeWidth = 0;

        for (var i = 0; i < slides.length; i++) {
          var el = slides[i];
          var height = el.offsetHeight;
          var width;

          if (height > 0 && trackHeight > 0) {
            var ratio = el.offsetWidth / height;
            var targetHeight = i === index ? trackHeight : trackHeight * INACTIVE_SCALE;
            width = Math.min(targetHeight * ratio, maxWidth);
          } else {
            width = el.offsetWidth;
          }

          if (i < index) left += width + gap;
          else if (i === index) activeWidth = width;
        }

        return left - (viewport.offsetWidth - activeWidth) / 2;
      }

      function render(offset) {
        track.style.transform = 'translateX(' + -offset + 'px)';
      }

      function updateClasses() {
        slides.forEach(function (el, i) {
          el.classList.toggle('is-active', i === current);
          el.classList.toggle('cs2-slide--before', i < current);
          el.classList.toggle('cs2-slide--after', i > current);
        });
      }

      function update() {
        updateClasses();
        currentOffset = offsetFor(current);
        render(currentOffset);
      }

      // Springt nach Erreichen eines äußeren Sets unsichtbar (ohne
      // Transition) zurück in die Mitte, damit unendlich weitergeblättert
      // werden kann, ohne dass die Bilder ausgehen.
      function recenterIfNeeded() {
        if (current >= originalCount && current < originalCount * 2) return;

        var withinSet = ((current % originalCount) + originalCount) % originalCount;
        current = originalCount + withinSet;

        track.style.transition = 'none';
        updateClasses();
        currentOffset = offsetFor(current);
        render(currentOffset);
        void track.offsetHeight;
        track.style.transition = '';
      }

      track.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'transform') return;
        recenterIfNeeded();
      });

      function goTo(index) {
        current = index;
        update();
      }

      /* ---------- Drag (Maus + Touch via Pointer Events) ----------
         Die Transform-Schreibvorgänge werden per requestAnimationFrame
         gebündelt, statt bei jedem pointermove synchron zu schreiben.
         Das war die Ursache für das ruckelige Drag-Verhalten am Desktop:
         hochfrequente Mausevents haben öfter geschrieben, als der
         Browser rendern konnte. */
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startOffset = 0;
      var lastX = 0;
      var lastTime = 0;
      var velocity = 0;
      var rafId = null;
      var pendingOffset = null;

      function flushRender() {
        rafId = null;
        if (pendingOffset !== null) {
          render(pendingOffset);
          pendingOffset = null;
        }
      }

      function scheduleRender(offset) {
        pendingOffset = offset;
        if (rafId === null) {
          rafId = window.requestAnimationFrame(flushRender);
        }
      }

      viewport.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        lastX = e.clientX;
        lastTime = e.timeStamp;
        velocity = 0;
        startOffset = currentOffset;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;

        var delta = e.clientX - startX;
        if (Math.abs(delta) > 4) moved = true;

        var dt = e.timeStamp - lastTime;
        if (dt > 0) velocity = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastTime = e.timeStamp;

        currentOffset = startOffset - delta;
        scheduleRender(currentOffset);

        if (moved) e.preventDefault();
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');

        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
          pendingOffset = null;
        }

        // Flick: schnelle Bewegung wechselt eine Slide weiter
        if (Math.abs(velocity) > 0.4) {
          goTo(velocity < 0 ? current + 1 : current - 1);
          return;
        }

        // Sonst: auf die Slide snappen, die der Mitte am nächsten ist
        var nearest = 0;
        var nearestDist = Infinity;
        slides.forEach(function (_, i) {
          var d = Math.abs(offsetFor(i) - currentOffset);
          if (d < nearestDist) {
            nearestDist = d;
            nearest = i;
          }
        });
        goTo(nearest);
      }

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('pointerleave', endDrag);

      // Klick auf Seitenbild = dorthin springen (nur wenn nicht gedraggt wurde)
      slides.forEach(function (el, i) {
        el.addEventListener('click', function () {
          if (moved) return;
          if (i !== current) goTo(i);
        });
      });

      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.cs2:not([data-cs2-init])');
      roots.forEach(initRoot);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cnt:not([data-cnt-init])').forEach(function (root) {
    root.setAttribute('data-cnt-init', '');

    var lightbox = root.querySelector('[data-cnt-lightbox]');
    var lightboxImg = root.querySelector('[data-cnt-lightbox-img]');
    var closeBtn = root.querySelector('[data-cnt-lightbox-close]');
    var triggers = root.querySelectorAll('[data-cnt-lightbox-trigger]');

    if (!lightbox || !lightboxImg) return;

    function openLightbox(src) {
      lightboxImg.src = src;
      lightbox.hidden = false;
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightboxImg.src = '';
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openLightbox(trigger.getAttribute('data-src'));
      });
    });

    closeBtn.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.section--featured-collection-slider').forEach(function (root) {
    var slider = root.querySelector('[data-fcs-slider]');
    var prev = root.querySelector('[data-fcs-prev]');
    var next = root.querySelector('[data-fcs-next]');
    var currentEl = root.querySelector('[data-fcs-current]');
    var totalEl = root.querySelector('[data-fcs-total]');
    if (!slider || !prev || !next) return;

    var items = Array.prototype.slice.call(slider.children);
    if (totalEl) totalEl.textContent = items.length;

    var scrollByItem = function (direction) {
      var item = items[0];
      var amount = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).gap || 0) : slider.clientWidth;
      slider.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    prev.addEventListener('click', function () {
      scrollByItem(-1);
    });

    next.addEventListener('click', function () {
      scrollByItem(1);
    });

    var update = function () {
      var max = slider.scrollWidth - slider.clientWidth;
      prev.setAttribute('aria-disabled', slider.scrollLeft <= 1 ? 'true' : 'false');
      next.setAttribute('aria-disabled', slider.scrollLeft >= max - 1 ? 'true' : 'false');

      if (currentEl && items.length) {
        var item = items[0];
        var step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).gap || 0);
        var index = step ? Math.round(slider.scrollLeft / step) : 0;
        currentEl.textContent = Math.min(items.length, index + 1);
      }
    };

    slider.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(slider);
    update();

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.featured-collections--body a').forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      link.classList.add('is-hovered');
    });
    link.addEventListener('mouseleave', function () {
      link.classList.remove('is-hovered');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('.hh');
    if (!hero || !('IntersectionObserver' in window)) {
      document.body.removeAttribute('data-has-hero');
      return;
    }

    var locked = false;
    var pendingState = null;

    function setPassed(value) {
      var current = document.body.getAttribute('data-hh-passed') === 'true';
      if (current === value) {
        pendingState = null;
        return;
      }
      document.body.setAttribute('data-hh-passed', value ? 'true' : 'false');
      locked = true;
      window.setTimeout(function () {
        locked = false;
        if (pendingState !== null) {
          var next = pendingState;
          pendingState = null;
          setPassed(next);
        }
      }, 500);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting;
          if (locked) {
            pendingState = passed;
          } else {
            setPassed(passed);
          }
        });
      },
      { threshold: 0, rootMargin: '-40px 0px -40px 0px' }
    );

    observer.observe(hero);

    function updateAnnouncementHeight() {
      var announcement = document.querySelector('.section--announcement');
      var height = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--hh-announcement-height', height + 'px');
    }

    updateAnnouncementHeight();
    window.addEventListener('resize', updateAnnouncementHeight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('body.template--product .product-form');
    if (!forms.length || !('ResizeObserver' in window)) return;

    forms.forEach(function (form) {
      var update = function () {
        if (window.innerWidth < 768) {
          form.style.position = '';
          return;
        }

        var offsetValue = getComputedStyle(form).getPropertyValue('--sticky-offset');
        var offset = parseFloat(offsetValue) || 0;
        var available = window.innerHeight - offset - 16;

        // Only sticky when it actually fits: a product-form taller than the
        // available viewport space would otherwise get pinned with its own
        // bottom (e.g. an open accordion) unreachable. When it doesn't fit,
        // fall back to normal in-flow scrolling with the rest of the page.
        form.style.position = form.scrollHeight > available ? 'static' : '';
      };

      new ResizeObserver(update).observe(form);
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var source = document.querySelector('.mgm-source');
      if (!source) return;
      var content = source.querySelector('.drawer--container[data-view="mega-menu"]');
      var leftSide = document.querySelector('drawer-element .drawer--side[data-side="left"]');
      if (!content || !leftSide) return;

      leftSide.appendChild(content);
      source.remove();

      if (window.trigger) {
        window.trigger('theme:drawer:loadTriggers');
      } else {
        document.dispatchEvent(new CustomEvent('theme:drawer:loadTriggers'));
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.section--recent-products').forEach(function (root) {
    var slider = root.querySelector('.recent-products--slider');
    var grid = root.querySelector('.recent-products--grid');
    var nav = root.querySelector('.recent-products--header-nav');
    var prev = root.querySelector('[data-rps-prev]');
    var next = root.querySelector('[data-rps-next]');
    if (!slider || !grid) return;

    var max = parseInt(grid.getAttribute('data-max-products'), 10) || 8;

    var step = function () {
      var card = grid.children[0];
      if (!card) return slider.clientWidth;
      return card.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).gap || 0);
    };

    if (prev) {
      prev.addEventListener('click', function () {
        slider.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        slider.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    // Cards are injected asynchronously, so trim to the configured maximum and
    // refresh the counter whenever the grid's children change.
    var update = function () {
      while (grid.children.length > max) {
        grid.removeChild(grid.lastElementChild);
      }


      var maxScroll = slider.scrollWidth - slider.clientWidth;
      if (nav) nav.classList.toggle('is-scrollable', maxScroll > 1);

      if (prev) prev.setAttribute('aria-disabled', slider.scrollLeft <= 1 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', slider.scrollLeft >= maxScroll - 1 ? 'true' : 'false');

    };

    slider.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(slider);
    new MutationObserver(update).observe(grid, { childList: true });
    update();

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  document.querySelectorAll('.section--related-products').forEach(function (root) {
    var slider = root.querySelector('[data-rp-slider]');
    var grid = root.querySelector('.related-products--grid');
    var prev = root.querySelector('[data-rp-prev]');
    var next = root.querySelector('[data-rp-next]');
    var currentEl = root.querySelector('[data-rp-current]');
    var totalEl = root.querySelector('[data-rp-total]');
    if (!slider || !grid) return;

    var items = function () {
      return Array.prototype.slice.call(grid.children);
    };

    var step = function () {
      var first = grid.children[0];
      if (!first) return slider.clientWidth;
      return first.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).gap || 0);
    };

    if (prev) {
      prev.addEventListener('click', function () {
        slider.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        slider.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    // Cards arrive asynchronously from the recommendations API, so the count and
    // the arrow states are recalculated whenever the grid's children change.
    var update = function () {
      var all = items();
      if (totalEl) totalEl.textContent = all.length;

      var max = slider.scrollWidth - slider.clientWidth;
      if (prev) prev.setAttribute('aria-disabled', slider.scrollLeft <= 1 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', slider.scrollLeft >= max - 1 ? 'true' : 'false');

      if (currentEl && all.length) {
        var s = step();
        var index = s ? Math.round(slider.scrollLeft / s) : 0;
        currentEl.textContent = Math.min(all.length, index + 1);
      }
    };

    slider.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(slider);
    new MutationObserver(update).observe(grid, { childList: true });
    update();

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.svc:not([data-svc-init])').forEach(function (root) {
    root.setAttribute('data-svc-init', '');

    // Deep links: /pages/services#svc-2 or #<custom anchor> opens that item and
    // scrolls to it. Runs on load and on hashchange, so in-page links work too.
    function itemForHash(hash) {
      if (!hash || hash.length < 2) return null;
      var id = hash.slice(1);
      var target = null;
      try {
        target = root.querySelector('#' + CSS.escape(id));
      } catch (e) {
        return null;
      }
      if (!target) return null;
      if (target.classList.contains('svc-item')) return target;
      // Custom anchors sit immediately before their <details>.
      var next = target.nextElementSibling;
      return next && next.classList.contains('svc-item') ? next : null;
    }

    function openFromHash(smooth) {
      var item = itemForHash(window.location.hash);
      if (!item) return;
      item.open = true;
      // The section is sticky-pinned and much taller than the viewport, so
      // scrolling to the item itself lands progressively deeper into the pinned
      // range the further down the item sits. Every deep link therefore lands on
      // the top of the section; only which item is open differs.
      // Wait a frame: the item has just been opened, so layout is not settled.
      requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      });
    }

    openFromHash(false);
    window.addEventListener('hashchange', function () {
      openFromHash(true);
    });

    var stickyOffsetPx = parseFloat(getComputedStyle(root).getPropertyValue('--svc-sticky-offset')) || 0;
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    var content = root.querySelector('.svc-content');
    var media = root.querySelector('.svc-media');
    if (content && media && !mobileQuery.matches) {
      var manualOffsetPx = parseFloat(getComputedStyle(root).getPropertyValue('--svc-content-offset')) || 0;
      var mediaHeightPx = media.getBoundingClientRect().height;
      var targetBottom = mediaHeightPx + 8 + manualOffsetPx;
      var naturalHeight = content.offsetHeight;
      var neededMarginTop = targetBottom - naturalHeight;
      if (neededMarginTop > 0) {
        content.style.marginTop = neededMarginTop + 'px';
      }
    }

    function pin(wrapSelector, innerSelector, clipRelease) {
      var wrap = root.querySelector(wrapSelector);
      var inner = root.querySelector(innerSelector);
      if (!wrap || !inner) return function () {};

      function reset() {
        inner.style.position = '';
        inner.style.top = '';
        inner.style.bottom = '';
        inner.style.left = '';
        inner.style.width = '';
        inner.style.clipPath = '';
      }

      function update() {
        if (mobileQuery.matches) {
          reset();
          return;
        }

        var wrapRect = wrap.getBoundingClientRect();
        var innerHeight = inner.offsetHeight;

        if (wrapRect.top > stickyOffsetPx) {
          inner.style.position = 'absolute';
          inner.style.top = '0';
          inner.style.bottom = '';
          inner.style.left = '0';
          inner.style.width = '100%';
          inner.style.clipPath = '';
        } else if (!clipRelease && wrapRect.bottom < stickyOffsetPx + innerHeight) {
          inner.style.position = 'absolute';
          inner.style.top = 'auto';
          inner.style.bottom = '0';
          inner.style.left = '0';
          inner.style.width = '100%';
        } else {
          inner.style.position = 'fixed';
          inner.style.top = stickyOffsetPx + 'px';
          inner.style.bottom = '';
          inner.style.left = wrapRect.left + 'px';
          inner.style.width = wrapRect.width + 'px';

          if (clipRelease) {
            var imageBottomOnScreen = stickyOffsetPx + innerHeight;
            var hiddenBottomPx = imageBottomOnScreen - wrapRect.bottom;
            if (hiddenBottomPx < 0) hiddenBottomPx = 0;
            if (hiddenBottomPx > innerHeight) hiddenBottomPx = innerHeight;
            inner.style.clipPath = 'inset(0px 0px ' + hiddenBottomPx + 'px 0px)';
          }
        }
      }

      return update;
    }

    var updateMedia = pin('.svc-media-wrap', '.svc-media', true);
    var updatePlate = pin('.svc-plate-wrap', '.svc-plate', true);

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateMedia();
        updatePlate();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', onScrollOrResize);
    }

    onScrollOrResize();
  });

  } catch(e) { console.error(e); }
})();
})();
